export default "__VITE_ASSET__1le3$GvM__"